<template>
  <div>
    <div class="matrix-scroll" v-for="(rowItem, id) of dataList.questionDetails.issue.items" :key="id">
      <span v-html="transformHtml(rowItem.content.text)"></span>
      <el-input-number
        v-if="isSlider"
        v-model="dataList.items[id].value"
        @change="handleChange(dataList)"
        :min="min"
        :max="max"
        size="mini"
        label="描述文字"
      ></el-input-number>
      <div v-if="isSlider" class="slider-style">
        <span style="padding-right: 15px">{{ leftText }}</span>
        <el-slider
          v-model.number="dataList.items[id].value"
          @change="handleChange(dataList)"
          input-size="mini"
          :min="min"
          :max="max"
          :marks="marks"
        ></el-slider>
        <span style="padding-left: 15px">{{ rightText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import '../public/style.css'
import { saveArr } from '../public/index.js'

export default {
  name: 'MatrixScroll',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      num: 0,
      marks: {},
      isSlider: false,
      min: null,
      max: null,
      leftText: '',
      rightText: '',
      dataList: []
    }
  },
  created() {
    this.rowData.items.forEach(element => {
      element.value = Number(element.value)
    })
    this.dataList = Object.assign({}, this.rowData)
  },
  mounted() {
    this.getSliderInfo()
  },
  inject: ['transformHtml'],
  methods: {
    getSliderInfo() {
      this.dataList.questionDetails.issue.labels.forEach((element, index) => {
        this.min = index == 0 ? element.num : this.min
        this.max = index == 1 ? element.num : this.max
        this.leftText = index == 0 ? element.text : this.leftText
        this.rightText = index == 1 ? element.text : this.rightText
      })
      this.marks[this.min] = this.min.toString()
      this.marks[this.max] = this.max.toString()
      this.isSlider = true
    },
    handleChange(row) {
      // if (this.updateArr.find((it, index) => it.questonId === row.questionId)) {
      //   this.updateArr.splice(index, 1)
      //   this.updateArr.push(row);
      // } else {
      //   this.updateArr.push(row);
      // }
      let ids = this.saveArr(this.dataList)
      if (ids !== -1) {
        this.updateArr.splice(ids, 1)
        this.updateArr.push(row)
      }
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped>
.slider-style {
  width: 100%;
  // height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  span {
    max-width: 15%;
    text-align: center;
    // padding: 0 5px;
    font-size: 14px;
    color: #38383a;
    margin-right: 10px;
  }
}
::v-deep .el-slider {
  // width: 80%;
  flex: 1;
}
.matrix-scroll > span {
  font-size: 12px;
  margin-right: 10px;
}
::v-deep .el-slider__marks-text {
  top: -10px;
  width: 35px;
}
</style>
